import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil, timeout } from 'rxjs/operators';
import { ElectionService } from 'src/app/services/election.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { RDColumn } from 'src/app/models/RDTable';
import { MatSort } from '@angular/material/sort';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { IReportFirstPreference } from 'src/app/interfaces/IReportFirstPreference';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { ITableHeader } from 'src/app/interfaces/ITableHeader';

@Component({
  selector: 'parties-currently-leading-table',
  templateUrl: './parties-currently-leading-table.component.html',
  styleUrls: ['./parties-currently-leading-table.component.scss']
})
export class PartiesCurrentlyLeadingTableComponent implements AfterViewInit, OnDestroy {

  @Input() isSmallTable = true;
  @Input() title = 'First Preference Votes';


  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public firstPreferences: IReportFirstPreference[] = [];

  public dataTable: IReportFirstPreference[] = [];
  public dataSource = new MatTableDataSource<IReportFirstPreference>();
  public columns: ITableHeader[] = [];
  public displayedColumns: string[] = [];
  public dataIsLoaded = true;
  public noTwoCPDataAvailable = false;
  public noDataDisclaimer = 'Two-candidate preferred count data is not yet available. This table will update automatically as 2CP results are counted.';

  constructor(private electionService: ElectionService) {
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (this.isDataLoaded(dataLoaded.electionDate)) {
        this.loadChart(this.electionService.selectedPage);
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.loadChart(page);
    });
  }


  private isDataLoaded(electionDateString: string): boolean {
    const election = this.electionService.electionMap.get(electionDateString);
    if (election) {
      return election.dataSourceTrigger([
        DataSourcesEnum.HAChange,
        DataSourcesEnum.HAStatic
      ]);
    }
    return false;
  }


  ngAfterViewInit(): void {
    if (this.isDataLoaded(this.electionService.selectedPage.electionDateString ?? '')) {
      this.loadChart(this.electionService.selectedPage);
    }
  }


  private loadChart(page: ISelectPage): void {
    this.columns = [];
    const election = this.electionService.electionMap.get(page.electionDateString ?? '');
    if (page.pageType === PageTypeEnum.CountHAStateWide) {
      this.firstPreferences = election?.electionCount?.parties
        .filter(x => x.leadingDistrictSeatCount > 0)
        .map(party => {
        return {
          district: null,
          partyId: party.partyId,
          party: `${party.partyName} (${party.partyId})`,
          colourCode: party.colourCode,
          candidateName: null,
          votes: party.leadingDistrictSeatCount,
          share: party.leadingDistrictSeatCountShare ?? 0,
          change: party.leadingDistrictSeatCountChange ?? 0
        };
      }) ?? [];
      this.firstPreferences.sort((a, b) => b.votes - a.votes);
    }

    this.columns.push({
      column: 'colourCode',
      label: '',
      labelTwo: '',
      isTwoRowLabel: false,
      minWidth: 20,
      isBold: false,
      isRightJustify: false,
      isPercent: false,
      isColour: true,
      isColourBar: false,
      colourCode: null
    });
    this.columns.push({
      column: 'party',
      label: 'Affiliation',
      labelTwo: '',
      isTwoRowLabel: false,
      minWidth: 60,
      isBold: false,
      isRightJustify: false,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });
    this.columns.push({
      column: 'votes',
      label: 'Seats',
      labelTwo: '',
      isTwoRowLabel: false,
      minWidth: 60,
      isBold: false,
      isRightJustify: true,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });
    this.columns.push({
      column: 'share',
      label: 'Share',
      labelTwo: '',
      isTwoRowLabel: false,
      minWidth: 60,
      isBold: false,
      isRightJustify: true,
      isPercent: true,
      isColour: false,
      isColourBar: true,
      colourCode: null
    });
    if (page.pageType === PageTypeEnum.CountHAStateWide) {
      // this.columns.push({
      //   column: 'change',
      //   label: 'Change',
      //   labelTwo: '',
      //   isTwoRowLabel: false,
      //   minWidth: 60,
      //   isBold: false,
      //   isRightJustify: true,
      //   isPercent: true,
      //   isColour: false,
      //   isColourBar: false
      // });
    }

    this.dataTable = this.firstPreferences;
    this.displayedColumns = this.columns.map(c => c.column);
    this.noTwoCPDataAvailable = this.dataTable?.length === 0;
    if (this.dataTable?.length > 0) {
      this.dataSource = new MatTableDataSource<IReportFirstPreference>(this.dataTable);
    }
  }




  isNumberType = (val: number | string): boolean => typeof val === 'number';

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
